import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '../i18n/useTranslation';
export default function LoadingSpinner() {
    const { t } = useTranslation();
    return (_jsx("div", { className: "flex min-h-[200px] items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center gap-3", children: [_jsx("div", { className: "h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" }), _jsx("span", { className: "text-sm text-[var(--text-secondary)]", children: t('common.loading') })] }) }));
}
